
<template>
  <div id="data-list-list-view" class="data-list-container">

    <vs-table ref="table" v-model="selected" pagination :max-items="itemsPerPage" search :data="persediaan">

      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
        <div>
          <div class="dropdown-button-container">
            <vs-button class="btnx" type="filled">Penyimpanan</vs-button>
            <vs-dropdown>
              <vs-button class="btn-drop" type="filled" icon="expand_more"></vs-button>
              <vs-dropdown-menu>
                <vs-dropdown-item :key="itemx.id" v-for="itemx in listGudang" :to="{path:`/stok/material/penyimpanan/${itemx.slug}`}">{{itemx.name}}</vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
          </div>
        </div>
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
          <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ persediaan.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : persediaan.length }} of {{ queriedItems }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>

          <vs-dropdown-menu>
            <vs-dropdown-item @click="itemsPerPage=10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=15">
              <span>15</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=20">
              <span>20</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th sort-key="no">No.</vs-th>
        <vs-th sort-key="barang">Barang</vs-th>
        <vs-th sort-key="satuan">Satuan</vs-th>
        <vs-th sort-key="harga">Harga</vs-th>
        <vs-th sort-key="kuantitas_masuk">Masuk</vs-th>
        <vs-th sort-key="kuantitas_keluar">Keluar</vs-th>
        <vs-th sort-key="jumlah">Jumlah</vs-th>
        <vs-th sort-key="total">Total</vs-th>
      </template>
      
      <template slot-scope="{data}">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

            <vs-td>
              <p class="product-name font-medium truncate">{{ indextr+1 }}.</p>
            </vs-td>

            <vs-td>
              <p class="product-name font-medium truncate">{{ tr.title }}</p>
            </vs-td>

            <vs-td>
              <p class="">{{ tr.unit_pemakaian }}</p>
              <vs-divider v-if="tr.konversi != 1"></vs-divider>
              <p class="" v-if="tr.konversi != 1"> {{ tr.unit_pembelian }} - {{ tr.konversi }} {{ tr.unit_pemakaian }}</p>
            </vs-td>

            <vs-td>
              <p class="">{{ tr.hpp_pemakaian | currency }}</p>
              <vs-divider v-if="tr.konversi != 1"></vs-divider>
              <p class="" v-if="tr.konversi != 1">{{ tr.hpp_pembelian | currency }}</p>
            </vs-td>

            <vs-td>
              <p class="">{{ formatUang(
                rounded((tr.debit * tr.konversi),1)
              ) }}</p>
              <vs-divider v-if="tr.konversi != 1"></vs-divider>
              <p class="" v-if="tr.konversi != 1">{{ tr.debit }}</p>
            </vs-td>

            <vs-td>
              <p class="">{{ formatUang(rounded((tr.kredit * tr.konversi),1)) }}</p>
              <vs-divider v-if="tr.konversi != 1"></vs-divider>
              <p class="" v-if="tr.konversi != 1">{{ formatUang(tr.kredit) }}</p>
            </vs-td>

            <vs-td>
              <p class="">{{ formatUang(
                rounded(
                  (tr.debit * tr.konversi)-(tr.kredit * tr.konversi),1)) }}</p>
              <vs-divider v-if="tr.konversi != 1"></vs-divider>
              <p class="" v-if="tr.konversi != 1">{{ formatUang((tr.debit)-(tr.kredit)) }}</p>
            </vs-td>

            <vs-td>
              <p class="font-medium truncate">{{ tr.hpp_pemakaian * (tr.debit * tr.konversi)-(tr.kredit * tr.konversi) | currency }}</p>
            </vs-td>

          </vs-tr>
        </tbody>
      </template>

    </vs-table>
  </div>
</template>

<script>
import modulePersediaan from '@/stores/accounting/persediaan/modulePersediaan.js'
import moduleGudang from '@/stores/term/gudang.js'
import { mapActions } from 'vuex'

export default {
  components: {
  },
  data () {
    return {
      selected: [],
      itemsPerPage: 10,
      isMounted: false
    }
  },
  computed: {
    currentPage () {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    persediaan () {
      return this.$store.state.persediaan.tasks
    },
    queriedItems () {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.persediaan.length
    },
    listGudang () {
      return this.$store.state.gudang.gudangs
    }
  },
  methods: {
    ...mapActions({
      setAuth   : 'auth/set',
    }),
    close() {
      this.$emit('closed', false)
    },
    logout() {
      this.setAuth({}) 
      this.$router.push('/login').catch(() => {})
    },
    rounded(value, precision) {
        var multiplier = Math.pow(10, precision || 0);
        return Math.round(value * multiplier) / multiplier;
    },
    formatUang(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    kalkulasi_konversi(debit,kredit,konversi) {
      let jum = debit - (debit*konversi-kredit) / konversi
      return jum.toFixed(4);
    },
  },
  created () {
    this.$store.registerModule('gudang', moduleGudang)
    this.$store.registerModule('persediaan', modulePersediaan)
    this.$store.dispatch('persediaan/fetchPersediaan', 'bahan-bangunan')
    this.$store.dispatch('gudang/fetchGudang')
  },
  beforeDestroy () {
    this.$store.unregisterModule('persediaan')
  },
  mounted () {
    this.isMounted = true
  }
}
</script>

<style lang="scss">
  #data-list-list-view {
    .vs-con-table {

      /*
        Below media-queries is fix for responsiveness of action buttons
        Note: If you change action buttons or layout of this page, Please remove below style
      */
      @media (max-width: 689px) {
        .vs-table--search {
          margin-left: 0;
          max-width: unset;
          width: 100%;

          .vs-table--search-input {
            width: 100%;
          }
        }
      }

      @media (max-width: 461px) {
        .items-per-page-handler {
          display: none;
        }
      }

      @media (max-width: 341px) {
        .data-list-btn-container {
          width: 100%;

          .dd-actions,
          .btn-add-new {
            width: 100%;
            margin-right: 0 !important;
          }
        }
      }

      .product-name {
        max-width: 23rem;
      }

      .vs-table--header {
        display: flex;
        flex-wrap: wrap;
        margin-left: 1.5rem;
        margin-right: 1.5rem;
        > span {
          display: flex;
          flex-grow: 1;
        }

        .vs-table--search{
          padding-top: 0;

          .vs-table--search-input {
            padding: 0.9rem 2.5rem;
            font-size: 1rem;

            &+i {
              left: 1rem;
            }

            &:focus+i {
              left: 1rem;
            }
          }
        }
      }

      .vs-table {
        border-collapse: separate;
        border-spacing: 0 1.3rem;
        padding: 0 1rem;

        tr{
            box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
            td{
              padding: 20px;
              &:first-child{
                border-top-left-radius: .5rem;
                border-bottom-left-radius: .5rem;
              }
              &:last-child{
                border-top-right-radius: .5rem;
                border-bottom-right-radius: .5rem;
              }
            }
            td.td-check{
              padding: 20px !important;
            }
        }
      }

      .vs-table--thead{
        th {
          padding-top: 0;
          padding-bottom: 0;

          .vs-table-text{
            text-transform: uppercase;
            font-weight: 600;
          }
        }
        th.td-check{
          padding: 0 15px !important;
        }
        tr{
          background: none;
          box-shadow: none;
        }
      }

      .vs-table--pagination {
        justify-content: center;
      }
    }
  }
  .dropdown-button-container {
    display: flex;
    align-items: center;

    .btnx {
      border-radius: 5px 0px 0px 5px;
    }

    .btn-drop {
      border-radius: 0px 5px 5px 0px;
      border-left: 1px solid rgba(255, 255, 255, .2);
    }
  }
</style>
